import { ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { IAuditTableQueryDto } from 'src/app/models/IAuditTableQueryDto';
import { HeaderService } from 'src/app/services/_app/header/header.service';
import { IAuditDto } from '../../../../models/IAuditDto';
import { IAuditLogEntryTimelineDetailsDto } from '../../../../models/IAuditLogEntryTimelineDetailsDto';
import { IDatabaseSimilarityDto } from '../../../../models/IDatabaseSimilarityDto';
import { ISavedViewDto } from '../../../../models/ISavedViewDto';
import { IFilterDto } from '../../../../models/IFilterDto';
import { ITableColumnsDto } from '../../../../models/ITableColumnsDto';
import { DataExplorerService } from '../../../../services/data-explorer/data-explorer.service';
import { BaseComponent } from '../../../base/base.component';

@Component({
  selector: 'app-lighthouse-data-explorer',
  templateUrl: './lighthouse-data-explorer.component.html',
  styleUrls: ['./lighthouse-data-explorer.component.css']
})
export class LighthouseDataExplorerComponent extends BaseComponent implements OnDestroy {

  @ViewChild('scrollableElement', { static: true }) scrollableElement!: ElementRef;

  @HostListener('scroll', ['$event'])

  outlined: any;
  tableDialogVisible = false;
  visible = false;
  public isCollapsed: boolean = false;
  public isViewMode: boolean = false;
  public databaseName: string = '';
  public connectionString: string = '';
  public all_tableCount: number = 0;
  public a_to_e_tableCount: number = 0;
  public f_to_j_tableCount: number = 0;
  public k_to_o_tableCount: number = 0;
  public p_to_t_tableCount: number = 0;
  public u_to_z_tableCount: number = 0;
  public isAllTableCountSelected: boolean = true;
  public is_A_to_E_TableCountSelected: boolean = false;
  public is_F_to_J_TableCountSelected: boolean = false;
  public is_K_to_O_TableCountSelected: boolean = false;
  public is_P_to_T_TableCountSelected: boolean = false;
  public is_U_to_Z_TableCountSelected: boolean = false;
  public a_to_e_tables: any = [];
  public f_to_j_tables: any = [];
  public k_to_o_tables: any = [];
  public p_to_t_tables: any = [];
  public u_to_z_tables: any = [];

  public tablesInViewCount: number = 0;
  public tablesInView: Array<any> = [];
  private isAwaitingData: boolean = false;
  private isInViewModeSubscription: Subscription;
  private loadSavedViewSubscription: Subscription;
  private deleteSavedViewSubscription: Subscription;

  public showFilterModal: boolean = false;
  resultMatch: any;
  dataView: boolean = false;
  isSaveViewModal: boolean = false;

  skeleton: boolean = true;

  messages: any;
  errorMessage: any;
  filterCard: string = '';
  filterSkeleton: string = '';
  copyData: Array<any> = [];
  sortColumn: string = '';
  sortDirection: string = 'asc';
  tableSortStates: Map<string, { column: string, direction: string }> = new Map();
  dataTableview: any;
  isSavedViewMode!: boolean;

  constructor(private dataExplorerService: DataExplorerService,
    private headerService: HeaderService,
    private cd: ChangeDetectorRef) {
    super();

    this.headerService.updateIsShowSavedViews(false);

    this.isInViewModeSubscription = this.headerService.isInViewMode$.subscribe(isInViewMode => {
      this.isViewMode = isInViewMode;
      if (!isInViewMode) {
        this.tablesInView = [];
        this.tablesInViewCount = 0;
        this.showFilteredTables('all');
      }
    });
    this.loadSavedViewSubscription = this.headerService.savedView$.subscribe(savedView => {
      if (savedView != undefined
        && savedView != null
        && !this.isEmptyObject(savedView)) {
        this.loadSavedView(savedView);
      }
    });
    this.deleteSavedViewSubscription = this.headerService.deletedSavedView$.subscribe(savedView => {
      if (savedView != undefined
        && savedView != null
        && !this.isEmptyObject(savedView)) {
        this.deleteSavedView(savedView);
      }
    });

    let _ = this.Audit;
    this.databaseName = _.DatabaseName;
    this.connectionString = _.ConnectionString;
  }

  override async ngOnInit() {
    this.isViewMode = false;
    //temp for view UI search layer
    setTimeout(() => {
      this.isSaveViewModal = false;
    }, 4000)
    await this.getLogEntriesRollupAsync();
    await this.getAuditProfileViews();
  }

  items: MenuItem[] = [
    {
      label: 'Rename Table',
      icon: 'pi pi-pencil'
    },
    {
      label: 'View Data-table',
      icon: 'pi pi-eye',
      // command: () => this.showTableViewDialog(data)
    },
    {
      label: 'Move to new section',
      icon: 'pi pi-folder',
    },
    {
      label: 'Delete forever',
      icon: 'pi pi-trash'
    }
  ];

  public async onScroll(event: Event, tableSchema: string, tableName: string): Promise<void> {
    let data = document.getElementById(`${tableName}_data`);
    var divHeight = data ? data.offsetHeight : 0;

    const verticalScrollPosition = (event.target as HTMLElement).scrollTop;
    //const horizontalScrollPosition = (event.target as HTMLElement).scrollLeft;

    verticalScrollPosition > divHeight / 2 ? console.log(`scrolled 50% ${tableName}`) : console.log(`scrolling ${tableName}`);

    // When 50% of the div is scrolled vertically
    // get more data from the server
    if (verticalScrollPosition > divHeight / 2 && !this.isAwaitingData) {
      /*
      this.isAwaitingData = true;
      let a: IAuditTableQueryDto = {} as IAuditTableQueryDto;
      a.AuditProfileId = this.Audit.Id;
      a.TableName = tableName;
      a.Filter = '';

      await this.dataExplorerService.getTableDataAsync(a).then((x: any) => {

        x.map((row: any) => {
          let tableUiRow: any = {
            auditType: row.AuditType,
            id: row.AuditId,
            modifiedBy: row.ModifiedBy,
            modifiedDate: row.ModifiedDate,
            tableColumns: row.TableColumns
          };

          this.allTables.find(x => x.name === tableName).data.push(tableUiRow);
        });

        //console.log(x);
        this.isAwaitingData = false;
      }).catch((err: any) => {
        console.log(err);
      });
      */
      await this.getTableData(tableSchema, tableName);
    }
  }

  private async getTableData(tableSchema: string, tableName: string) {
    this.isAwaitingData = true;
    let a: IAuditTableQueryDto = {} as IAuditTableQueryDto;
    a.AuditProfileId = this.Audit.Id;
    a.TableName = tableName;
    a.TableSchema = tableSchema;
    a.Filter = {} as IFilterDto;
    debugger;
    await this.dataExplorerService.getTableDataAsync(a).then((x: any) => {

      x.map((row: any) => {
        let tableUiRow: any = {
          AuditType: row.AuditType,
          AuditId: row.AuditId,
          ModifiedBy: row.ModifiedBy,
          ModifiedDate: row.ModifiedDate,
          TableColumns: row.TableColumns
        };

        this.allTables.find(x => x.name === tableName).data.push(tableUiRow);
      });

      this.isAwaitingData = false;
    }).catch((err: any) => {
      console.log(err);
    });
  }

  public allTables: Array<any> = [];
  public viewableTables: Array<any> = [];
  private logs: Array<any> = [];
  public oldRecords: any = [];

  reverseLog = [...this.logs].sort((a, b) => b.id - a.id);

  rowClass(index: number): string {
    return index % 2 === 0 ? 'even-row' : 'odd-row';
  }

  public allTableColumns: Array<ITableColumnsDto> = [];

  // Gets the data for all the tables in the Audit DB (500 records at a time per table)
  private async getLogEntriesRollupAsync() {
    this.headerService.setSpinner(true);
    let a: IAuditDto = this.Audit;

    await this.dataExplorerService.getLogEntriesTimelineDetailsAsync(a.Id).then((x: Array<Array<IAuditLogEntryTimelineDetailsDto>>) => {
      x.map((a) => {
        let o: any = {
          name: '',
          schema: '',
          data: []
        };
        o.schema = a[0].TableSchema;
        o.name = a[0].TableName;

        const firstLetter = o.name[0].toUpperCase();
        this.all_tableCount += 1;

        if ('A' <= firstLetter && firstLetter <= 'E') {
          this.a_to_e_tableCount += 1;
          this.a_to_e_tables.push(o.name);
        } else if ('F' <= firstLetter && firstLetter <= 'J') {
          this.f_to_j_tableCount += 1;
          this.f_to_j_tables.push(o.name);
        } else if ('K' <= firstLetter && firstLetter <= 'O') {
          this.k_to_o_tableCount += 1;
          this.k_to_o_tables.push(o.name);
        } else if ('P' <= firstLetter && firstLetter <= 'T') {
          this.p_to_t_tableCount += 1;
          this.p_to_t_tables.push(o.name);
        } else if ('U' <= firstLetter && firstLetter <= 'Z') {
          this.u_to_z_tableCount += 1;
          this.u_to_z_tables.push(o.name);
        }

        a.map((r) => {
          let z: any = {
            AuditType: r.AuditType,
            AuditId: r.AuditId,
            ModifiedBy: r.ModifiedBy,
            ModifiedDate: r.ModifiedDate,
            TableColumns: r.TableColumns
          };

          this.allTableColumns.push(...r.TableColumns);

          o.data.push(z);
        });

        this.allTables.push(o);
      });

      this.viewableTables = this.allTables?.sort((a, b) => a.name.localeCompare(b.name));
      this.copyData = JSON.parse(JSON.stringify(this.allTables));
      this.skeleton = false;
      this.headerService.setSpinner(false);

      // Used to inject ALL POSSIBLE columns into the "Universal Search Modal"
      // remove duplicates
      this.allTableColumns = this.allTableColumns.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          t.Name === thing.Name
        ))
      );

      // sort
      this.allTableColumns = this.allTableColumns.sort((a, b) => a.Name.localeCompare(b.Name));
    }).catch((err: any) => {
      this.headerService.setSpinner(false);
      this.skeleton = false;
      this.headerService.setSpinner(false);
      console.log(err);
    });
  }

  // TODO: Fix typo
  showTableViewDialog(data: any) {
    var a = this.allTables.filter(x => x.name === data.name)[0];
    //debugger;
    this.visible = true;
    this.dataTableview = a;
  }

  close(event: boolean) {
    this.visible = !event;
    this.tableDialogVisible = !event;
  }

  openMenu(menu: any, event: any) {
    menu.toggle(event);
  }

  showFilteredTables(selectedFilter: string) {
    this.headerService.setSpinner(true);
    this.viewableTables = [];
    this.allTables = this.copyData;

    this.isAllTableCountSelected = false;
    this.is_A_to_E_TableCountSelected = false;
    this.is_F_to_J_TableCountSelected = false;
    this.is_K_to_O_TableCountSelected = false;
    this.is_P_to_T_TableCountSelected = false;
    this.is_U_to_Z_TableCountSelected = false;

    // Alphabatic sorting
    this.allTables?.sort((a, b) => a.name.localeCompare(b.name));

    switch (selectedFilter) {
      case 'all':
        this.isAllTableCountSelected = true;
        this.viewableTables = this.allTables;

        if (this.allTables.length) {
          setTimeout(() => {
            this.headerService.setSpinner(false);
          }, 3000);
        }
        break;
      case 'a_to_e':
        this.is_A_to_E_TableCountSelected = true;
        this.viewableTables = this.allTables.filter(x => this.a_to_e_tables.includes(x.name));
        this.headerService.setSpinner(false);
        break;
      case 'f_to_j':
        this.is_F_to_J_TableCountSelected = true;
        this.viewableTables = this.allTables.filter(x => this.f_to_j_tables.includes(x.name));
        this.headerService.setSpinner(false);
        break;
      case 'k_to_o':
        this.is_K_to_O_TableCountSelected = true;
        this.viewableTables = this.allTables.filter(x => this.k_to_o_tables.includes(x.name));
        this.headerService.setSpinner(false);
        break;
      case 'p_to_t':
        this.is_P_to_T_TableCountSelected = true;
        this.viewableTables = this.allTables.filter(x => this.p_to_t_tables.includes(x.name));
        this.headerService.setSpinner(false);
        break;
      case 'u_to_z':
        this.is_U_to_Z_TableCountSelected = true;
        this.viewableTables = this.allTables.filter(x => this.u_to_z_tables.includes(x.name));
        this.headerService.setSpinner(false);
        break;
    }
  }

  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  /////////////////// Views
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////

  currentSavedView: string = '';
  currentSavedViewId: string = '';

  private async getAuditProfileViews() {
    let a = this.Audit;
    await this.dataExplorerService.getLighthouseViewsAsync(a.DatabaseName).then((x: Array<any>) => {
      this.headerService.setSavedViews(x);
    }).catch((err: any) => {

    });
  }

  addTableToView(table: any) {
    if (this.tablesInViewCount === 0) {
      this.headerService.updateIsInViewMode(true);
    }

    this.isViewMode = true;
    this.tablesInView.push(table);
    this.tablesInViewCount += 1;
  }

  removeTableFromView(table: any) {
    this.tablesInView = this.tablesInView.filter(x => x.name !== table.name);
    this.tablesInViewCount -= 1;

    this.checkIfNeedToExitViewMode();
  }

  checkIfNeedToExitViewMode() {
    if (this.tablesInViewCount === 0) {
      this.isViewMode = false;
      this.headerService.updateIsInViewMode(false);
      this.showFilteredTables('all');
    }
  }

  isTableInView(table: any): boolean {
    return this.tablesInView.includes(table);
  }

  async saveView() {
    this.isSaveViewModal = true;
  }

  addNewView() {
    this.dataView = !this.dataView;
  }

  seeSavedViews() {
    this.headerService.updateIsShowSavedViews(true);
  }

  async deleteSavedView(savedView: any) {
    let _ = this.Audit;

    await this.dataExplorerService.deleteViewAsync(savedView.Id, _.DatabaseName).then(async (x) => {
      await this.getAuditProfileViews();
    }).catch((err) => {

    });
  }

  seeAllViewTables() {
    this.viewableTables = this.tablesInView;
  }

  udpateViewTables() {
    this.viewableTables = this.tablesInView;
  }

  removeFromTablesInView(table: any) {
    this.tablesInView = this.tablesInView.filter(x => x.name !== table.name);
    this.tablesInViewCount -= 1;

    this.udpateViewTables();
    this.checkIfNeedToExitViewMode();
  }

  async loadSavedView(savedView: any) {
    this.skeleton = true;
    // this.headerService.setSpinner(true);
    this.currentSavedView = savedView.ViewName;
    this.currentSavedViewId = savedView.Id;

    this.tablesInView = [];
    this.allTables = [];
    this.tablesInViewCount = 0;
    this.viewableTables = [];

    await this.loadFilteredViewsData(savedView);

    this.viewableTables = this.allTables;
    this.tablesInView = this.viewableTables;
    this.tablesInViewCount = this.tablesInView.length;

    if (this.tablesInViewCount > 0) {
      this.headerService.updateIsInViewMode(true);
      this.isViewMode = true;
    }
  }

  async loadFilteredViewsData(savedView: ISavedViewDto) {
    const loadedTables = new Set<string>(); // Set to store loaded table names

    let isFilter: boolean = false;
    //this.tablesInView = [];

    for (const [index, record] of savedView.Tables2.entries()) {
      if (!record.Filter) {
        const tablesToLoad = this.copyData.filter((x: any) => savedView.Tables2.some((table:any) => table.Name === x.name) && !loadedTables.has(x.name));
        this.allTables = [...this.allTables, ...tablesToLoad];
        tablesToLoad.forEach(table => loadedTables.add(table.name));

        this.skeleton = false;
        this.viewableTables = this.allTables;
        this.showFilterModal = false;
        this.currentTableSchemaForFilter = '';
        this.currentTableForFilter = '';
        this.tablesInView = this.viewableTables;
        this.tablesInViewCount = this.tablesInView.length;
        this.isAwaitingData = false;
        this.filterSkeleton = '';

        if (this.tablesInViewCount > 0) {
          this.headerService.updateIsInViewMode(true);
          this.isViewMode = true;
        }
        // this.headerService.setSpinner(false);
      } else {
        if (!loadedTables.has(record.Name)) {
          isFilter = true;
          let a: IAuditTableQueryDto = {} as IAuditTableQueryDto;

          if (savedView?.Id) {
            a.AuditProfileId = this.Audit.Id;
            a.TableName = record.Name;
            a.TableSchema = record.Schema;
            a.Filter = JSON.parse(record.Filter);
          }

          // add function 
          await this.filterSavedDataView(a);

          loadedTables.add(record.Name); // Add the table name to the set after loading
        }
      }
    }

    // set this so that loadSavedView() will have the "tablesInView" array populated
    if (isFilter) {
      this.tablesInView = this.allTables;
    }
  }

  async handleViewNameSaved(event: string) {
    this.headerService.setSpinner(true);

    let tableArray: any = [];


    this.tablesInView.map((x) => {
      tableArray.push({ Schema: x.schema, Name: x.name });
    });

    let _: any = {
      AuditProfileId: this.Audit.Id,
      Tables2: tableArray,
      DatabaseName: this.databaseName,
      ViewName: event,
      Id: this.currentSavedViewId
    };

    this.isSaveViewModal = false;
    this.currentSavedView = '';
    this.currentSavedViewId = '';

    await this.dataExplorerService.saveViewAsync(_).then(async (x: any) => {
      await this.getAuditProfileViews();
      this.headerService.setSpinner(false);
    }).catch((err: any) => {
      console.log(err);
    });

    console.log(_);
  }

  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  /////////////////// Filter
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////

  tableColumnsForFilter: any;
  currentTableSchemaForFilter: string = '';
  currentTableForFilter: string = '';

  toggleFilterModal(table: any) {
    let alreadyFilter;
    if (this.showFilterModal) {
      this.showFilterModal = false;
      this.currentTableSchemaForFilter = '';
      this.currentTableForFilter = '';
      this.filterCard = '';
    } else {
      this.currentTableSchemaForFilter = table.schema;
      this.currentTableForFilter = table.name;
      this.filterCard = table.name;
      this.showFilterModal = true;

      let x: any = this.getColumnNames(table.data);
      this.tableColumnsForFilter = x.slice().sort();

      let result = this.viewableTables.filter(x => x.name == table.name);
      this.resultMatch = result[0];

    }
  }

  clearFilterData(value: any) {
    const tableName = value?.name;

    const matchingIndex = this.allTables.findIndex(x => x.name === tableName);

    if (matchingIndex !== -1) {
      const resetData = this.oldRecords.find((x: any) => x[0].name === tableName)?.[0]?.data || [];

      this.allTables[matchingIndex].data = resetData;
      this.allTables[matchingIndex].filtered = false;
      this.allTables[matchingIndex].condition = '';

      const recordIndex = this.oldRecords.findIndex((x: any) => x[0].name === tableName);
      if (recordIndex !== -1) {
        this.oldRecords.splice(recordIndex, 1);
      }
    }

    this.showFilterModal = false;
    this.currentTableSchemaForFilter = '';
    this.currentTableForFilter = '';
    this.filterCard = '';
  }

  /*
  * Apply filter to the table
  */
  async applyFilter(event: any) {
    this.filterCard = '';
    this.filterSkeleton = this.currentTableForFilter;

    this.isAwaitingData = true;
    let a: IAuditTableQueryDto = {} as IAuditTableQueryDto;
    a.AuditProfileId = this.Audit.Id;
    a.TableSchema = this.currentTableSchemaForFilter;
    a.TableName = this.currentTableForFilter;
    this.filterCard = this.currentTableForFilter;

    a.Filter = this.convertToIFilterDto(event);

    await this.getFilteredDataAsync(a);
  }

  private async getFilteredDataAsync(a: IAuditTableQueryDto) {
    await this.dataExplorerService.getTableDataAsync(a).then((x: any) => {

      this.messages = [{ severity: 'success', summary: 'Filter', detail: 'applied successfully' }];

      // 1. Empty all tables
      this.bindFilteredDataUI(x, this.currentTableForFilter);

      // close filter modal
      this.closeFilter();

      this.isAwaitingData = false;
      this.filterSkeleton = '';
    }).catch((err: any) => {
      this.errorMessage = [
        { severity: 'error', summary: 'Invalid query!', detail: 'Check your filter logic!' },
      ];
      this.filterCard = '';
      this.filterSkeleton = '';

      console.log(err);
    });
  }

  private closeFilter() {
    this.showFilterModal = false;
    this.currentTableSchemaForFilter = '';
    this.currentTableForFilter = '';
  }

  private bindFilteredDataUI(x: any, tableName: string) {
    this.allTables.find(x => x.name === tableName).data = [];

    x.map((row: any) => {
      let tableUiRow: any = {
        AuditType: row.AuditType,
        AuditId: row.AuditId,
        ModifiedBy: row.ModifiedBy,
        ModifiedDate: row.ModifiedDate,
        TableColumns: row.TableColumns
      };

      this.allTables.find(x => x.name === tableName).data.push(tableUiRow);
    });
  }

  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  /////////////////// Utils
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////

  getColumnNames(dataArray: any) {
    const columnNames = new Set(); // Using a Set to store unique values

    dataArray.forEach((item: any) => {
      Object.keys(item).forEach(key => {
        if (key !== 'TableColumns') {
          columnNames.add(key); // Add keys from the main object
        }
      });

      // Assuming `tableColumns` is an array of objects with a property `name`
      if (Array.isArray(item.TableColumns)) {
        item.TableColumns.forEach((col: any) => {
          columnNames.add(col.Name); // Add the 'name' from the tableColumns array
        });
      }
    });

    return [...columnNames]; // Convert Set back to Array
  }

  public collapseExpandTables() {
    this.isCollapsed = !this.isCollapsed
  }

  ngOnDestroy(): void {
    this.isInViewModeSubscription.unsubscribe();
    this.loadSavedViewSubscription.unsubscribe();
    this.deleteSavedViewSubscription.unsubscribe();

    this.headerService.updateIsInViewMode(false);
    this.headerService.updateIsShowSavedViews(false);
    this.headerService.loadSavedView(null);

    // reset variables
    this.isCollapsed = false;
    this.isViewMode = false;
    this.databaseName = '';
    this.connectionString = '';
    this.all_tableCount = 0;
    this.a_to_e_tableCount = 0;
    this.f_to_j_tableCount = 0;
    this.k_to_o_tableCount = 0;
    this.p_to_t_tableCount = 0;
    this.u_to_z_tableCount = 0;
    this.isAllTableCountSelected = true;
    this.is_A_to_E_TableCountSelected = false;
    this.is_F_to_J_TableCountSelected = false;
    this.is_K_to_O_TableCountSelected = false;
    this.is_P_to_T_TableCountSelected = false;
    this.is_U_to_Z_TableCountSelected = false;
    this.a_to_e_tables = [];
    this.f_to_j_tables = [];
    this.k_to_o_tables = [];
    this.p_to_t_tables = [];
    this.u_to_z_tables = [];
    this.tablesInViewCount = 0;
    this.tablesInView = [];
    this.isAwaitingData = false;
    this.showFilterModal = false;
    this.filterCard = '';
    this.filterSkeleton = '';
    this.copyData = [];
    this.sortColumn = '';
    this.sortDirection = 'asc';
    this.tableSortStates = new Map();
    this.dataTableview = '';
    this.isSavedViewMode = false;
    this.currentSavedView = '';
    this.currentSavedViewId = '';
    this.tableColumnsForFilter = '';
    this.currentTableSchemaForFilter = '';
    this.currentTableForFilter = '';
  }

  private toPascalCase(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  private convertToIFilterDto(obj: any): any {
    if (Array.isArray(obj)) {
      // Use an arrow function to maintain the correct `this` context
      return obj.map((o) => this.convertToIFilterDto(o));
    } else if (obj !== null && typeof obj === 'object') {
      return Object.keys(obj).reduce((acc: any, key: string) => {
        const pascalKey = this.toPascalCase(key);
        acc[pascalKey] = this.convertToIFilterDto(obj[key]);
        return acc;
      }, {});
    }
    return obj;
  }

  /*
  * Called when loading a Saved View that has a Filter
  */
  async filterSavedDataView(a: any) {
    try {
      await this.dataExplorerService.getTableDataAsync(a).then(async (x) => {
        this.messages = [{ severity: 'success', summary: `Filter: ${a.TableName}`, detail: 'applied successfully' }];

        let z: any = {
          AuditType: x[0].AuditType,
          AuditId: x[0].AuditId,
          ModifiedBy: x[0].ModifiedBy,
          ModifiedDate: x[0].ModifiedDate,
          TableColumns: x[0].TableColumns
        };
        let o: any = {
          name: a.TableName,
          data: []
        };
        o.data.push(z);

        this.allTables.push(o);

        this.bindFilteredDataUI(x, a.TableName);
      }).catch((err) => {

      });
      //let x: any = await this.dataExplorerService.getTableDataAsync(a);
      //this.messages = [{ severity: 'success', summary: 'Filter', detail: 'applied successfully' }];
      //x.map((r: any) => {
      //  let o: any = {
      //    name: '',
      //    data: []
      //  };
      //  o.name = r.TableName;
      //  this.all_tableCount += 1;
      //  let z: any = {
      //    AuditType: r.AuditType,
      //    AuditId: r.AuditId,
      //    ModifiedBy: r.ModifiedBy,
      //    ModifiedDate: r.ModifiedDate,
      //    TableColumns: r.TableColumns
      //  }
      //  o.data.push(z);
      //  console.log("z", z);
      //  console.log("z", o);

      //  if (this.allTables.length === 0 || this.allTables?.find(x => x.name === a.TableName)?.length === 0) {
      //    this.allTables.push(o);
      //  } else {
      //    this.allTables.find(x => x.name === a.TableName).data.push(o);
      //  }
      //});
      this.skeleton = false;

      //this.viewableTables = this.allTables;
      //this.tablesInView = this.viewableTables;
      //this.tablesInViewCount = this.tablesInView.length;

      //this.showFilterModal = false;
      //this.currentTableForFilter = '';
      //this.isAwaitingData = false;
      //this.filterSkeleton = ''; 

      //if (this.tablesInViewCount > 0) {
      //  this.headerService.updateIsInViewMode(true);
      //  this.isViewMode = true;
      //}
      // this.headerService.setSpinner(false);
    } catch (err) {
      this.skeleton = false;
      // this.headerService.setSpinner(false);
      this.errorMessage = [
        { severity: 'error', summary: 'Invalid query!', detail: 'Check your filter logic!' },
      ];
      this.filterCard = '';
      console.log(err);
      this.filterSkeleton = '';
    }
  }

  sortData(table: any, column: any) {
    let sortState = this.tableSortStates.get(table.name);

    if (!sortState || sortState.column !== column) {
      sortState = { column, direction: 'asc' };
    } else {
      sortState.direction = sortState.direction === 'asc' ? 'desc' : 'asc';
    }
    this.tableSortStates.set(table.name, sortState);
    if (column == "AuditType" || column == "AuditId" || column == "ModifiedBy" || column == "ModifiedDate") {
      table.data = this.sortTableData(table.data, sortState.column, sortState.direction);
    } else {
      table.data = this.sortTableDataDynamic(table.data, column, sortState.direction);
    }
  }

  sortTableData(data: any[], columnName: string, direction: string) {
    return data.sort((a, b) => {
      const valueA = a[columnName];
      const valueB = b[columnName];

      if (valueA === valueB) return 0;

      if (direction === 'asc') {
        return valueA > valueB ? 1 : -1;
      } else {
        return valueA < valueB ? 1 : -1;
      }
    });
  }

  sortTableDataDynamic(data: any[], columnName: string, direction: string) {
    return data.sort((a, b) => {
      const valueA = a.TableColumns.find((col: any) => col.Name === columnName)?.Value;
      const valueB = b.TableColumns.find((col: any) => col.Name === columnName)?.Value;

      if (valueA === valueB) return 0;

      if (direction === 'asc') {
        return valueA > valueB ? 1 : -1;
      } else {
        return valueA < valueB ? 1 : -1;
      }
    });
  }

  getValueToCompare(value: any): any {
    if (typeof value === 'string') {
      return value.toLowerCase();
    }
    return value;
  }

  getSortIcon(table: any, column: string): string {
    const sortState = this.tableSortStates.get(table.name);

    if (sortState && sortState.column === column) {
      return sortState.direction === 'asc' ? 'pi-sort-up' : 'pi-sort-down';
    } else {
      return 'pi-sort';
    }
  }

  isEmptyObject(obj: any) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  /////////////////// Search Utilities
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////

  public isShowUniversalSearchModal: boolean = false;
  public isShowUniversalSoftDeleteSearchModal: boolean = false;
  public isShowUniversalJoinsModal: boolean = false;
  public isShowUniversalSimilaritiesModal: boolean = false;

  public isInShowUniversalSearchMode: boolean = false;
  public isInShowUniversalSoftDeleteSearchMode: boolean = false;
  public isInShowUniversalJoinsMode: boolean = false;
  public isInShowUniversalSimilaritiesMode: boolean = false;

  showUniversalSearchModal() {
    this.isShowUniversalSearchModal = true;
    this.isInShowUniversalSearchMode = true;
  }

  showUniversalSoftDeleteSearchModal() {
    this.isShowUniversalSoftDeleteSearchModal = true;
    this.isInShowUniversalSoftDeleteSearchMode = true;
  }

  showUniversalJoinsModal() {
    this.isShowUniversalJoinsModal = true;
    this.isInShowUniversalJoinsMode = true;
  }

  showUniversalSimilaritiesModal() {
    this.isShowUniversalSimilaritiesModal = true;
    this.isInShowUniversalSimilaritiesMode = true;
  }

  dialogCloseEmitter(e: boolean) {
    this.isShowUniversalSearchModal = e;
    this.isShowUniversalSoftDeleteSearchModal = e;
    this.isShowUniversalJoinsModal = e;
    this.isShowUniversalSimilaritiesModal = e;
  }

  public async beginUniversalSearch(userSearchDto: any) {
    this.isInShowUniversalSearchMode = true;
    this.headerService.setSpinner(true);
    this.skeleton = true;

    userSearchDto.AuditProfileId = this.Audit.Id;

    await this.dataExplorerService.searchLogEntriesUserActivity(userSearchDto).then((x: Array<Array<IAuditLogEntryTimelineDetailsDto>>) => {
      let allTempTables: Array<any> = [];

      x.map((a) => {
        let o: any = {
          name: '',
          data: []
        };
        o.name = a[0].TableName;

        a.map((r) => {
          let z: any = {
            AuditType: r.AuditType,
            AuditId: r.AuditId,
            ModifiedBy: r.ModifiedBy,
            ModifiedDate: r.ModifiedDate,
            TableColumns: r.TableColumns
          };

          this.allTableColumns.push(...r.TableColumns);

          o.data.push(z);
        });

        allTempTables.push(o);
      });

      this.viewableTables = allTempTables?.sort((a, b) => a.name.localeCompare(b.name));

      this.skeleton = false;
      this.headerService.setSpinner(false);

    }).catch((err: any) => { });

  }

  public async beginUniversalSoftDeleteSearch(userSearchDto: any) {
    this.isInShowUniversalSoftDeleteSearchMode = true;
    this.headerService.setSpinner(true);
    this.skeleton = true;

    userSearchDto.AuditProfileId = this.Audit.Id;

    await this.dataExplorerService.searchSoftDeletesLogEntriesUserActivity(userSearchDto).then((x: Array<Array<IAuditLogEntryTimelineDetailsDto>>) => {
      let allTempTables: Array<any> = [];

      x.map((a) => {
        let o: any = {
          name: '',
          data: []
        };
        o.name = a[0].TableName;

        a.map((r) => {
          let z: any = {
            AuditType: r.AuditType,
            AuditId: r.AuditId,
            ModifiedBy: r.ModifiedBy,
            ModifiedDate: r.ModifiedDate,
            TableColumns: r.TableColumns
          };

          this.allTableColumns.push(...r.TableColumns);

          o.data.push(z);
        });

        allTempTables.push(o);
      });

      this.viewableTables = allTempTables?.sort((a, b) => a.name.localeCompare(b.name));

      this.skeleton = false;
      this.headerService.setSpinner(false);

    }).catch((err: any) => { });

  }

  public tablesWithoutAuditData: Array<any> = [];

  public async beginJoinsSearch() {
    this.isInShowUniversalJoinsMode = true;
    this.headerService.setSpinner(true);
    //this.skeleton = true;

    const auditId = this.Audit.Id;

    await this.dataExplorerService.searchDatabaseJoinsAsync(auditId).then((x: Array<IDatabaseSimilarityDto>) => {
      let allTempTables: Array<any> = [];

      x.map((a: IDatabaseSimilarityDto) => {
        // find the table in the allTables array


        // TODO: Also validate by schema. (Need to update the allTables to have the schema as well, API should be sending it back)
        let table = this.allTables.find(x => x.name === a.SourceTable.Name);

        if (table === undefined) {
          this.tablesWithoutAuditData = this.tablesWithoutAuditData.concat(a.SourceTable.Name);
          return;
        }

        table.IsShowJoins = true;
        table.JoinCount = 0;

        // find what columns are being joined
        a.ReferenceTables.map((r) => {
          if (table.ReferenceTables === undefined) {
            table.ReferenceTables = [];
          }

          table.ReferenceTables.push(r);
          //debugger;
          let tableColumns: Array<any> = [];
          tableColumns = table.data[0].TableColumns;
          var sourceJoinColumn = tableColumns.find(q => q.Name === r.Columns[0].Name);

          sourceJoinColumn.IsJoinColumn = true;

          if (sourceJoinColumn.ColumnJoinCount === undefined) {
            sourceJoinColumn.ColumnJoinCount = 0;
          }

          table.JoinCount += 1;
          sourceJoinColumn.ColumnJoinCount += 1;
          sourceJoinColumn.IsShowJoinBadge = true;

          //table.data[0].TableColumns.map((firstRow: any) => {
          //  let tableColumns: Array<any> = [];
          //  tableColumns = firstRow.TableColumns;
          //  var sourceJoinColumn = tableColumns.find(q => q.Name === r.Columns[0].Name);

          //  sourceJoinColumn.IsJoinColumn = true;

          //  if (sourceJoinColumn.ColumnJoinCount === undefined) {
          //    sourceJoinColumn.ColumnJoinCount = 0;
          //  }

          //  table.JoinCount += 1;
          //  sourceJoinColumn.ColumnJoinCount += 1;
          //  sourceJoinColumn.IsShowJoinBadge = true;
          //});

          //table.data.map((row: any) => {
          //  //if (tableRowCounter === 0) {
          //  //  let tableColumns: Array<any> = [];
          //  //  tableColumns = row.TableColumns;
          //  //  var sourceJoinColumn = tableColumns.find(q => q.Name === r.Columns[0].Name);
          //  //  //let sourceJoinColumn = .find((q: any) => q.Name === r.Columns[1].Name)[0];
          //  //  sourceJoinColumn.IsJoinColumn = true;

          //  //  if (sourceJoinColumn.ColumnJoinCount === undefined) {
          //  //    sourceJoinColumn.ColumnJoinCount = 0;
          //  //  }

          //  //  table.JoinCount += 1;
          //  //  sourceJoinColumn.ColumnJoinCount += 1;
          //  //  sourceJoinColumn.IsShowJoinBadge = true;

          //  //} else {
          //  //  return;
          //  //}
          //})
        });

        // TODO: Also validate by schema. (Need to update the allTables to have the schema as well, API should be sending it back)
        this.allTables.find(x => x.name === a.SourceTable.Name)[0] = table;

        // update the viewable table with the new data
        this.viewableTables.find(x => x.name === a.SourceTable.Name)[0] = table;

      });

      //this.viewableTables = allTempTables?.sort((a, b) => a.name.localeCompare(b.name));

      //this.skeleton = false;
      this.headerService.setSpinner(false);

    }).catch((err: any) => { });

  }

  public async beginSimilaritiesSearch(similaritiesSearchDto: any) {
    this.isInShowUniversalSimilaritiesMode = true;
    this.headerService.setSpinner(true);

    similaritiesSearchDto.AuditProfileId = this.Audit.Id;

    await this.dataExplorerService.searchDatabaseSimilaritiesAsync(similaritiesSearchDto).then((x: Array<Array<IAuditLogEntryTimelineDetailsDto>>) => {
      let allTempTables: Array<any> = [];

      x.map((a) => {
        let o: any = {
          name: '',
          data: []
        };
        o.name = a[0].TableName;

        a.map((r) => {
          let z: any = {
            AuditType: r.AuditType,
            AuditId: r.AuditId,
            ModifiedBy: r.ModifiedBy,
            ModifiedDate: r.ModifiedDate,
            TableColumns: r.TableColumns
          };

          this.allTableColumns.push(...r.TableColumns);

          o.data.push(z);
        });

        allTempTables.push(o);
      });

      this.viewableTables = allTempTables?.sort((a, b) => a.name.localeCompare(b.name));

      this.skeleton = false;
      this.headerService.setSpinner(false);

    }).catch((err: any) => { });

  }

  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  ///////////////////
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////

}
